import React from 'react';
import '../style/aboutpage.css';
import laptopMockup from '../assets/laptopcrypto.webp'; 


export default function AboutPage() {
  return (
    // The main container with the dark background
    <div className="hero-container">
      <div className="hero-content-wrapper">
        
        {/* LEFT COLUMN: Laptop Mockup Image */}
        <div className="hero-left">
          <img 
            src={laptopMockup} 
            alt="VaultX Crypto Trading Interface Mockup" 
            className="laptop-image" 
          />
        </div>
        
        {/* RIGHT COLUMN: Text and Button */}
        <div className="hero-right">
          <h1 className="hero-title">What is VaultX Crypto?</h1>
          
          <p className="hero-paragraph">
             <strong>VaultX Crypto</strong> is your all-in-one digital asset platform. Seamlessly trade 
            and manage your portfolio with powerful tools for every market condition. 
            We offer secure access to a variety of transaction types.
          </p>
          
          {/* Feature List */}
          <div className="feature-list">
            
            <div className="feature-item">
              {/* Using a Font Awesome icon class for a modern look */}
              <i className="check-icon fas fa-check-circle"></i>
              <div className="feature-text-group">
                <h2 className="feature-title">Real-Time Crypto Market Data</h2>
                <p className="feature-description">
                  View and analyze <strong>real-time prices</strong> and charting for all major 
                  cryptocurrencies to execute trades with precision.
                </p>
              </div>
            </div>
            
            <div className="feature-item">
              <i className="check-icon fas fa-check-circle"></i>
              <div className="feature-text-group">
                <h2 className="feature-title">Diversified Trading Options</h2>
                <p className="feature-description">
                  Access advanced tools including  <strong>Spot Trade, Futures, P2P, Staking,</strong> and <strong>Margin</strong> to maximize your potential returns.
                </p>
              </div>
            </div>
          </div>
          
          <button className="explore-button">Get Started Now</button>
        </div>
      </div>
    </div>
  );
}